<div class="d-flex align-items-center">
  <mat-icon class="border-radius-full info-icon">{{ data?.icon }}</mat-icon>
  <p class="flex-one ml-2">{{ data?.message }}</p>
  <mat-icon class="pointer ml-2 close-icon mat-20" (click)="snackBarRef.dismiss()">close</mat-icon>
</div>
